import { FC } from "react";
import { SuggestionsListButton, SuggestionsListWrapper } from "./style";
import { LogoSvg } from "shared/ui/logoSvg";
import { PreloaderContainer } from "shared/ui/preloaderContainer";

type SuggestionsListOption = {
  name: string; 
  value: string
}

interface SuggestionsListProps {
  isShow: boolean;
  list: SuggestionsListOption[],
  onClick?: (value: string) => void,
  minHeight?: number
}

export const SuggestionsList: FC<SuggestionsListProps> = ({
  isShow = false,
  list,
  onClick,
  minHeight = 100
}) => {
  if (!isShow) return <></>

  return (
    <SuggestionsListWrapper $minHeight={minHeight}>
      {list.length ? list.map((el, index) => {
        return <SuggestionsListButton key={index} onClick={() => onClick?.(el.value)}>{el.name}</SuggestionsListButton>
      }) : <PreloaderContainer $height={minHeight} $pathAnimDuration={1} ><LogoSvg /></PreloaderContainer>}
    </SuggestionsListWrapper>
  )
}